module.exports = __webpack_public_path__ + "img/dining-3.e031c201.png";